<div class="form-group">
  <label [for]="inputId" *ngIf="!suppressLabel">{{ translateTag | translate: translateParams }}</label>
  <div
    ngbDropdown
    #myDrop="ngbDropdown"
    [autoClose]="'outside'"
    placement="bottom-left"
    (openChange)="dropdownIsOpen = $event; setSearch(searchString)"
    [id]="inputId"
    class="p-0"
    [class.form-control]="!renderStatic"
  >
    <button
      type="button"
      [disabled]="renderStatic || disabled"
      class="w-100 border-0 text-left dropdown"
      [ngClass]="{ 'btn btn-block': !renderStatic }"
      ngbDropdownToggle
    >
      <div class="d-flex align-items-center">
        <span class="w-100 text-truncate">{{ value }}&nbsp;</span>
        <i
          *ngIf="value && !disabled && !renderStatic"
          class="fal fa-times mx-2"
          role="button"
          (click)="$event.stopPropagation(); $event.preventDefault(); value = ''; onTouched()"
        ></i>
        <i
          *ngIf="!renderStatic"
          class="fa float-right ml-auto"
          [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
        ></i>
      </div>
    </button>
    <ul class="dropdown-list" ngbDropdownMenu>
      <li (keydown.enter)="$event.preventDefault()">
        <lib-filter-list-search (searchUpdated)="setSearch($event)"></lib-filter-list-search>
      </li>
      <li *ngIf="showAddNew" class="item">
        <button type="button" class="btn w-100 text-left" (click)="selected(searchString); myDrop.close()">
          {{ 'ADD_NEW_ASSORTMENT' | translate }}: "{{ searchString }}"
        </button>
      </li>
      <li *ngIf="filteredList.length === 0 && !showAddNew">
        <span translate>NO_RESULTS_FOUND</span>
      </li>
      <li *ngFor="let item of filteredList" class="item">
        <button type="button" class="btn w-100 text-left" (click)="selected(item); myDrop.close()">
          {{ item }}
        </button>
      </li>
    </ul>
  </div>
</div>
